import { appConfig } from "../config";
import {getCookie} from "../utils";

export class EventBase {
    constructor(name, screen, { anonymous = false } = {}) {
 
        const redirectURI = getCookie("cs_redirect") || appConfig.defaultRedirectTo;
        const regex = /^(?:https?:\/\/)?(?:www\.)?([a-zA-Z0-9-]+)\./
 
        this.name=name;    
        this.screen=screen;
        this.anonymous=anonymous;
        this.source=/^(?:https?:\/\/)?localhost(?:\/|\?|:\d+|$)/.test(redirectURI) ? 'localhost' :
                    regex.test(redirectURI) ? redirectURI.match(regex)[1] :
                    redirectURI;
    }
    
}
export class ButtonTapEventBase extends EventBase {
    constructor(screen, label, buttonId, name="Tap") {
        super(name, screen);
        this.buttonId=buttonId
        this.label=label;
        this.TapType='Button'
    }
}

export class CustomEventBase extends EventBase{
    constructor(name, screen, method, type, reason, { anonymous = false } = {}) {
        super(name, screen, { anonymous })
        this.type=type;
        this.method = method;
        this.reason = reason;  
    }
}
export class LinkTapEventBase extends EventBase {
    constructor(screen, label, link) {
        super('Tap', screen);
        this.toLink=link
        this.label=label;
        this.TapType='Link'
    }
}

export class NavigationEventBase extends EventBase {
    constructor(screen, toPage) {
        super('Navigation', screen);
        this.toPage=toPage
    }
}
export class PageViewEventBase extends EventBase {
    constructor() {
        super('PageView', '');
    }
}

export class LoginEventBase extends EventBase {
    constructor(screen) {
        super('Login',screen);
    }
}